import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { PASPrdService } from '../../../services/PASPrd.service';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';
import { ILocationProductionResponse } from '../../Interfaces/ilocation';
import { listPOGTypes, POGStatus, POGType, UpdatePasOptionGroup } from '../../Interfaces/iproduction';

@Component({
  selector: 'app-compositiondetail',
  templateUrl: './compositiondetail.component.html'
})

export class CompositionDetailComponent implements OnInit {
  formEdit: FormGroup;
  subRef$: Subscription;
  matcher = new ErrorStateMatcher1();
  message: string = "";
  productionLocations: ILocationProductionResponse[];

  constructor(
    private formBuilder: FormBuilder,
    private PASPrdService:PASPrdService,
    private dialogRef: MatDialogRef<CompositionDetailComponent>,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formEdit = formBuilder.group({
      name: { value: "", disabled: true },
      status: { value: 1, disabled: true },
      validator: ['x',[Validators.required]]
    });
  }
  _Code: string;
  _TypeName: string;
  listTypes: listPOGTypes[] = [{ id: 1, name: 'Selección única' }, { id: 2, name: 'Selección  múltiple' }];
  id: number;

  ngOnInit() {
    this.id = this.data.id
    this.message = "";
    this.GetData();
  }

  GetData()
  {
    this.PASPrdService.GetGroupComponent(this.id).subscribe(result => {
      if (result.body.isValid) {
        this._Code = result.body.resultData.code;
        this._TypeName = result.body.resultData.typeName;
        this.formEdit.get('name').setValue(result.body.resultData.name);
        this.formEdit.get('status').setValue(result.body.resultData.status);
        this.formEdit.get('validator').setValue('x');
      }
      else {
        alert(result.body.error.description);
      }
    }, (e) => {
      alert(e);
      return;
    });
  }

  Cancel() {
    this.dialogRef.close();
  }

  Save() {
    try {
      let _Message = "";
      const _Data: UpdatePasOptionGroup = {
        id: this.id,
        status: (this.formEdit.value.status == 1 ? POGStatus.ACTIVE : POGStatus.INACTIVE),
        name: this.formEdit.value.name,
        type: (this.formEdit.value.type == 1 ? POGType.UNIQUESELECTION : POGType.MULTIPLESELECTION)
      };
      this.formEdit.get('Validator').setValue('');

      //this.PASPrdService.UpdatePOG(_Data).pipe(finalize(() => this.OTPFinish(_Items, PId, _Count)))
      this.PASPrdService.UpdatePOG(_Data).subscribe(result => {
        if (result.body.isValid) {
          _Message = result.body.resultData.description;
          this.openSB(_Message);
          this.dialogRef.close(true);

        }
        else {
          alert(result.body.error.description);
          return;
        }
      }, (e) => {
        alert(e);
        return;
      });
    }
    catch (e) {
      console.log(e.message);
      alert(e.message);
    }
  }

  b_Back() {
    this.dialogRef.close(true);
  }

  hasError(nombreControl: string, validacion: string) {
    const control = this.formEdit.get(nombreControl);
    return control.hasError(validacion);
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 3000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

  ngOnDestroy(): void {
  }
}
